export default {
  subjectData: state => state.subjectData,
  subjectGrade: state => state.subjectGrade,
  subjectToLabel: state => state.subjectToLabel
}
